/**
 * Utility method to convert a message id to timestamp. This can be used to compare message ids to sort
 *
 * @param messageId The message id
 * @returns The timestamp
 */
export function convertMessageIdToTimestamp(messageId?: string) {
  if (!messageId)
    return 0

  const chunks = messageId.split('-')
  const timestamp = Number.parseInt(chunks[0] + chunks[1], 16)

  // JS timestamp is 10 times more, so multiply by 10
  return timestamp * 10
}
